// FIXME: the color is saved as an int in the DB, which is then linked to one of these hex values
// We should be saving the hex value instead
// Edit: is this a hardcoded color book?
export const symbolColors = [
  '#000000',
  '#00ff00',
  '#ff0000',
  '#ffff00',
  '#0000ff',
  '#00ffff',
  '#ff00ff',
  '#ffffff',
  '#c0c0c0',
  '#008000',
  '#800000',
  '#808000',
  '#000080',
  '#008080',
  '#800000',
  '#808080',
];
